export default "__VITE_ASSET__D$s27JJv__"